import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class ThankYou extends Page{
    constructor(){
        super({
            id : 'thank_you',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}